// export const activities_endpoint=(selectedOrg,selectedType,selectedDay)=>`/v2/guest/filter-events/?filter_date=${selectedDay}&ngo_id=${selectedOrg}&event_type_id=${selectedType}&time=`
export const activities_endpoint=`/v2/guest/filter-events`
